export const selectPersonByIrnAndType = (state, irn, personType) => {
  const getPersonsWithNameMap = state.personsWithName?.personsWithNameMap || {};
  const key = `${irn}-${personType}`;
  return getPersonsWithNameMap[key] || null;
};